export interface ComboBoxOption<T = string> {
  label: string;
  value: string;
  item?: T;
}

export const ComboBoxDefault: ComboBoxOption = {
  label: "",
  value: "",
  item: undefined,
};
